import { useState } from 'react';
import { Card, Container, Spinner } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { AiOutlineCamera, AiOutlineMail } from 'react-icons/ai';
import { BiEditAlt, BiLogOutCircle, BiUserCheck } from 'react-icons/bi';
import { CgProductHunt } from 'react-icons/cg';
import { FaIdCard, FaTicketAlt } from 'react-icons/fa';
import { FiSmartphone } from 'react-icons/fi';
import { RiKeyLine } from 'react-icons/ri';
import { Link, Outlet, useLocation } from 'react-router-dom';
import Layout from '../../../Components/Layout/Layout';
import { VisitorAuthContext } from '../../../Context/AuthContex/VisitorAuthContext';
import { AUTH_VISITOR_USER_FAILED, imgUrl } from '../../../Helpers/Constant';
import {
  useGetVisitorProfileData,
  useVisitorProfileUpdate,
} from '../apiEndpoints/VisitorApiEndpoints';
import { MdPayment } from 'react-icons/md';

const VisitorProfile = () => {
  const location = useLocation();
  const { dispatch: VisitorAuthDispatch } = VisitorAuthContext();
  const { data } = useGetVisitorProfileData();
  const { mutate, isPending } = useVisitorProfileUpdate();
  const handleLogout = () => {
    localStorage.removeItem('toab_visitor_token');
    VisitorAuthDispatch?.({
      type: AUTH_VISITOR_USER_FAILED,
    });
  };

  const handelImageUpdate = async (img: any) => {
    const formData = new FormData();
    formData.append('visitor_photo', img);
    mutate(formData);
  };
  const [open, setOpen] = useState(false);
  return (
    <Layout pathName={'Visitor Profile'} showHeader>
      {/* {!data?.data?.has_ticket && (
        <CommonModal
          modalOff={open}
          children={
            <TicketingPopup
              onChange={() => {
                setOpen(true);
              }}
            />
          }
        />
      )} */}

      <div>
        <Container>
          <Row>
            <Col xs={12} md={4}>
              <Row style={{ marginBottom: '20px' }}>
                <Col>
                  <Card className='profile-left-side'>
                    <div className='user-profile-header d-flex flex-column align-items-center text-center bg-light p-4 rounded shadow-sm'>
                      <div className='position-relative'>
                        <img
                          src={
                            !data?.data?.visitor_photo
                              ? '/blank-image.png'
                              : `${imgUrl}/${data?.data?.visitor_photo}`
                          }
                          height={150}
                          width={150}
                          alt='User Profile'
                          // className='rounded-circle border border-secondary shadow-sm mb-3'
                          className='rounded-3 user-profile-img d-block  ms-0 ms-sm-4'
                          style={{ objectFit: 'cover' }}
                        />
                        <div className='position-absolute bottom-0 end-0 bg-white rounded-circle p-1 shadow'>
                          {isPending ? (
                            <Spinner
                              animation='border'
                              variant='primary'
                              size='sm'
                            />
                          ) : (
                            <label htmlFor='file' className='m-0'>
                              <AiOutlineCamera
                                size={25}
                                className='pointer text-primary'
                              />
                              <input
                                type='file'
                                id='file'
                                onChange={(e: any) =>
                                  handelImageUpdate(e?.target?.files[0])
                                }
                                hidden
                              />
                            </label>
                          )}
                        </div>
                      </div>
                      <div className='mt-3'>
                        <h4 className='fw-bold text-primary mb-3'>
                          {data?.data?.visitor_first_name}{' '}
                          {data?.data?.visitor_last_name}
                        </h4>
                        <ul className='list-inline mb-0'>
                          <li className='list-inline-item d-flex align-items-center gap-2'>
                            <AiOutlineMail className='text-secondary' />
                            <span>{data?.data?.visitor_email}</span>
                          </li>
                          <li className='list-inline-item d-flex align-items-center gap-2 mt-2'>
                            <FiSmartphone className='text-secondary' />
                            <span>{data?.data?.visitor_phone}</span>
                          </li>
                          <li className='list-inline-item d-flex align-items-center gap-2 mt-2'>
                            <FaIdCard className='text-secondary' />
                            <span>{data?.data?.visitor_no}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>

              <div className='profile-left-side  ps-4 py-3'>
                <div>
                  <Link
                    to='/visitor/ticketing-request'
                    className={
                      location.pathname === `/visitor/ticketing-request`
                        ? 'profile-left-side-link-active'
                        : 'profile-left-side-link'
                    }
                  >
                    <div className='d-flex align-items-center gap-2'>
                      <FaTicketAlt />
                      <p>Ticketing Request</p>
                    </div>
                  </Link>
                  {/* <Link
                    to='/visitor/register-event'
                    className={
                      location.pathname === `/visitor/register-event`
                        ? 'profile-left-side-link-active'
                        : 'profile-left-side-link'
                    }
                  >
                    <div className='d-flex align-items-center gap-2 '>
                      <CgCalendarDates />
                      <p>Registered Events</p>
                    </div>
                  </Link> */}

                  <Link
                    to='/visitor/profile'
                    className={
                      location.pathname === `/visitor/profile`
                        ? 'profile-left-side-link-active'
                        : 'profile-left-side-link'
                    }
                  >
                    <div className='d-flex align-items-center gap-2 py-3'>
                      <CgProductHunt />
                      <p>Profile</p>
                    </div>
                  </Link>
                  <Link
                    to='/visitor/edit-profile'
                    className={
                      location.pathname === '/visitor/edit-profile'
                        ? 'profile-left-side-link-active'
                        : 'profile-left-side-link'
                    }
                  >
                    <div className='d-flex align-items-center gap-2 '>
                      <BiEditAlt />
                      <p>Edit Profile</p>
                    </div>
                  </Link>

                  <Link
                    to='/visitor/invoice'
                    className={
                      location.pathname === '/visitor/invoice'
                        ? 'profile-left-side-link-active'
                        : 'profile-left-side-link'
                    }
                  >
                    <div className='d-flex align-items-center gap-2 pt-3'>
                      <MdPayment />
                      <p>Payment</p>
                    </div>
                  </Link>

                  <Link
                    to='/visitor/wishlist'
                    className={
                      location.pathname === '/visitor/wishlist'
                        ? 'profile-left-side-link-active'
                        : 'profile-left-side-link'
                    }
                  >
                    <div className='d-flex align-items-center gap-2 py-3'>
                      <BiUserCheck />
                      <p>My Wishlist</p>
                    </div>
                  </Link>
                  <Link
                    to='/visitor/change-password'
                    className={
                      location.pathname === '/visitor/change-password'
                        ? 'profile-left-side-link-active'
                        : 'profile-left-side-link'
                    }
                  >
                    <div className='d-flex align-items-center gap-2 pb-3'>
                      <RiKeyLine />
                      <p>Change Password</p>
                    </div>
                  </Link>

                  <div
                    className='d-flex align-items-center gap-2 pointer'
                    onClick={handleLogout}
                  >
                    <BiLogOutCircle />
                    <p>Logout</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} md={8}>
              <div className='mt-5 mt-md-0'>
                <Outlet />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default VisitorProfile;
